import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { FileText, Loader2, ShieldCheck } from 'lucide-react';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';
import { CommitmentText, openCommitmentPdf } from './CommitmentText';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Firma: lokasyonun güncel İSG taahhütnamesini onaylamadıysa döner (yoksa / onaylıysa null)
export const fetchPendingCommitment = (locationId) => axios.get(`${API}/firm/isg-commitment/pending`, { params: { location_id: locationId } })
  .then(r => r.data.commitment).catch(() => null);

export const CommitmentGateDialog = ({ commitment, permitId, onAccepted, onClose }) => {
  const [readToEnd, setReadToEnd] = useState(false);
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);
  const onScroll = (e) => { const el = e.currentTarget; if (el.scrollTop + el.clientHeight >= el.scrollHeight - 12) setReadToEnd(true); };
  const accept = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/firm/isg-commitment/${commitment.id}/accept`, null, { params: permitId ? { permit_id: permitId } : {} });
      toast.success('İSG taahhütnamesi onaylandı');
      onAccepted();
    } catch (err) { toast.error(err.response?.data?.detail || 'Onay kaydedilemedi'); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent className="max-w-3xl max-h-[92vh] flex flex-col" data-testid="commitment-gate-dialog" aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-emerald-600" />{commitment.title}<span className="text-xs font-normal text-slate-500">(Sürüm {commitment.version})</span></DialogTitle>
        </DialogHeader>
        <p className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900">Talep oluşturmadan önce bu lokasyonun İSG taahhütnamesini okuyup onaylamanız gerekir. Metni sonuna kadar okuyun.</p>
        <div onScroll={onScroll} ref={(el) => el && el.scrollHeight <= el.clientHeight + 12 && !readToEnd && setReadToEnd(true)}
          className="min-h-0 flex-1 overflow-y-auto rounded-lg border bg-white p-4" data-testid="commitment-gate-scroll">
          <CommitmentText content={commitment.content} />
          {commitment.pdf_name && (
            <button type="button" onClick={() => openCommitmentPdf(commitment.id, true)} className="mt-4 inline-flex items-center gap-1.5 rounded-md border border-sky-300 bg-sky-50 px-3 py-1.5 text-xs font-semibold text-sky-800 hover:bg-sky-100" data-testid="commitment-gate-pdf-btn">
              <FileText className="h-4 w-4" />Ek: {commitment.pdf_name}
            </button>
          )}
        </div>
        <label className={`flex items-center gap-2 rounded-md border px-3 py-2 text-sm ${readToEnd ? 'border-emerald-300 bg-emerald-50 text-emerald-900' : 'border-slate-200 bg-slate-50 text-slate-400'}`}>
          <Checkbox checked={checked} disabled={!readToEnd} onCheckedChange={(v) => setChecked(!!v)} data-testid="commitment-gate-checkbox" />
          Okudum, anladım ve kabul ediyorum.{!readToEnd && ' (önce metni sonuna kadar kaydırın)'}
        </label>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={busy} data-testid="commitment-gate-cancel">Vazgeç</Button>
          <Button onClick={accept} disabled={!checked || busy} className="bg-emerald-600 text-white hover:bg-emerald-700" data-testid="commitment-gate-accept">
            {busy && <Loader2 className="mr-1 h-4 w-4 animate-spin" />}Onayla ve Devam Et
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
